import React, { useState, useEffect, useCallback } from 'react'
import { useRouter } from 'next/router'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'

import { Body, Title, Row, Drawer, Button, Radio, Checkbox, Loader } from '../../src/components'
import { Card } from 'routes/Campaigns/components'

import { useUser } from 'context/user-context'

import { convertUTCToDate } from 'helpers'

import { getCampaigns, getPhotos } from 'services/v3'

import { DrawerTitle, Form, ButtonInfo } from 'routes/Campaigns/style'
/* import { getModalCampaing, setModalCampaing } from 'helpers' */

const Campaigns = () => {
  const { user } = useUser()
  const router = useRouter()

  const { handleSubmit, control, setValue } = useForm()

  const [loading, setLoading] = useState(false)
  const [campaings, setCampaings] = useState([])
  const [filteredCampaings, setFilteredCampaings] = useState([])
  const [isOpenFilter, setIsOpenFilter] = useState(false)
  /*   const [isOpenModal, setIsOpenModal] = useState(false) */
  const [rowLength, setRowLength] = useState(12)
  const [pageSelected, setPageSelected] = useState(0)
  const [filterValue, setFilterValue] = useState({
    all: true,
    completed: false,
    waiting: false,
    formalization: false,
    capture: false
  })

  const handleOrderCampaings = useCallback(
    filterValue => {
      try {
        let order = []

        if (filterValue.all) {
          const newOrder = campaings
          order = newOrder
        } else {
          if (filterValue.completed) {
            const newOrder = campaings.filter(item => {
              return [2, 6, 7, 8, 9, 10, 11, 12, 13, 3].includes(item.campaign_status_id)
            })
            order = order.concat(newOrder)
          }
          if (filterValue.waiting) {
            const newOrder = campaings.filter(item => {
              return item.campaign_status_id === 4
            })
            order = order.concat(newOrder)
          }
          if (filterValue.formalization) {
            const newOrder = campaings.filter(item => {
              return false
            })
            order = order.concat(newOrder)
          }
          if (filterValue.capture) {
            const newOrder = campaings.filter(item => {
              return item.campaign_status_id === 1
            })
            order = order.concat(newOrder)
          }
        }

        const responseFiltered = order.map(item => item)

        setFilteredCampaings(responseFiltered)
      } catch (err) {
        console.log(err)
      }
    },
    [campaings]
  )

  const handleFilter = useCallback(
    data => {
      try {
        setRowLength(Number(data.pagination))
        handleOrderCampaings(filterValue)
      } catch (err) {
        toast.error('Não foi possível realizar esse filtro.')
      } finally {
        setIsOpenFilter(false)
      }
    },
    [handleOrderCampaings, filterValue]
  )

  useEffect(() => {
    if (!user) {
      return
    }
    const fetchInfos = async () => {
      try {
        const campaignResponse = await getCampaigns()

        const campaing = await Promise.all(
          campaignResponse.map(async campaign => {
            let campaignPhotos = []
            try {
              const respCampaignPhotos = await getPhotos({ campaign_id: campaign.id })
              campaignPhotos = respCampaignPhotos ? respCampaignPhotos : []
            } catch (error) {
              console.log(error, error.message)
              return campaign
            }

            return {
              ...campaign,
              brand_image:
                campaignPhotos.length !== 0
                  ? campaignPhotos.find(
                      ({ campaign_photo_type_id, campaign_photo_type, photo_url }) =>
                        campaign_photo_type_id && photo_url && campaign_photo_type.abbreviation === 'B'
                    )
                  : null
            }
          })
        )

        const validCampaigns = campaing
          .filter(campaign => {
            const serverTime = convertUTCToDate(new Date(campaign.publication_date)).valueOf()
            const currentTime = new Date().valueOf()

            return (
              campaign.published === 1 &&
              campaign.campaign_status_id &&
              (campaign.publication_date === null || currentTime - serverTime >= 0)
            )
          })
          .sort((a, b) => b.id - a.id)

        setCampaings(validCampaigns)
        setLoading(true)
        /* let showModal = getModalCampaing()
        if (showModal === 'true') {
          setIsOpenModal(true)
          setModalCampaing(false)
        } */
      } catch (error) {
        console.log(error, error.message)
        toast.error('Erro ao buscar Campanhas')
      }
    }

    fetchInfos()
  }, [user, router.query])

  useEffect(() => {
    handleOrderCampaings({ all: true })
  }, [campaings])

  if (!loading) {
    return (
      <Body header='Campanhas'>
        <Row mb='24px'>
          <Title title='Campanhas' mr='13.67px' />
        </Row>
        <Loader />
      </Body>
    )
  }

  return (
    <Body header='Campanhas'>
      <Row mb='24px'>
        <Title title='Campanhas' mr='13.67px' />
        {/* <ButtonInfo onClick={() => setIsOpenModal(!isOpenModal)}>
          <img src='/img/info.svg' alt='Detalhes' />
        </ButtonInfo> */}
      </Row>

      <Card
        campaing={filteredCampaings}
        hasPaginationTop
        hasPaginationBottom
        offset={pageSelected}
        rowCount={rowLength}
        navigationTo={setPageSelected}
        openFilter={() => setIsOpenFilter(true)}
        filterValue={filterValue}
        handleFilterCleaning={() => {
          setRowLength(12)
          setFilterValue({
            all: true,
            completed: false,
            waiting: false,
            formalization: false,
            capture: false
          })
          handleOrderCampaings({ all: true })
        }}
      />

      <Drawer
        anchor='right'
        open={isOpenFilter}
        onClose={() => setIsOpenFilter(false)}
        iconClose
        titleContainer={<DrawerTitle>Filtrar</DrawerTitle>}
      >
        <Form onSubmit={handleSubmit(data => handleFilter(data))}>
          <main>
            <section>
              <h2>Status da campanha:</h2>

              <Checkbox
                control={control}
                name='Emcaptação'
                label='Em captação'
                checked={filterValue.capture}
                onChange={() =>
                  setFilterValue({
                    all: false,
                    completed: filterValue.completed,
                    waiting: filterValue.waiting,
                    formalization: filterValue.formalization,
                    capture: !filterValue.capture
                  })
                }
              />
              <Checkbox
                control={control}
                name='waitlist'
                label='Lista de espera'
                checked={filterValue.waiting}
                onChange={() =>
                  setFilterValue({
                    all: false,
                    completed: filterValue.completed,
                    waiting: !filterValue.waiting,
                    formalization: filterValue.formalization,
                    capture: filterValue.capture
                  })
                }
              />
              <Checkbox
                control={control}
                name='Emformalização'
                label='Em formalização'
                checked={filterValue.formalization}
                onChange={() =>
                  setFilterValue({
                    all: false,
                    completed: filterValue.completed,
                    waiting: filterValue.waiting,
                    formalization: !filterValue.formalization,
                    capture: filterValue.capture
                  })
                }
              />
              <Checkbox
                control={control}
                name='Concluída'
                label='Concluída'
                checked={filterValue.completed}
                onChange={() =>
                  setFilterValue({
                    all: false,
                    completed: !filterValue.completed,
                    waiting: filterValue.waiting,
                    formalization: filterValue.formalization,
                    capture: filterValue.capture
                  })
                }
              />
              <Checkbox
                control={control}
                name='todos'
                label='Todos'
                checked={filterValue.all}
                onChange={() =>
                  setFilterValue({
                    all: !filterValue.all,
                    completed: false,
                    waiting: false,
                    formalization: false,
                    capture: false
                  })
                }
              />
            </section>

            <section>
              <h2>Itens por página:</h2>

              <Radio
                control={control}
                name='pagination'
                defaultValue={String(rowLength)}
                options={[
                  {
                    value: '12',
                    label: '12 itens'
                  },
                  {
                    value: '18',
                    label: '18 itens'
                  },
                  {
                    value: '24',
                    label: '24 itens'
                  },
                  {
                    value: '-1',
                    label: 'Todos'
                  }
                ]}
              />
            </section>
          </main>

          <footer>
            {filterValue.all === true && rowLength === 12 ? (
              <Button type='submit'>Filtrar</Button>
            ) : (
              <Row style={{ justifyContent: 'space-between', gap: '24px', width: '100%' }}>
                <Button
                  variant='outlined'
                  onClick={() => {
                    setValue('pagination', '12')
                    setFilterValue({
                      all: true,
                      completed: false,
                      waiting: false,
                      formalization: false,
                      capture: false
                    })
                  }}
                >
                  Limpar filtros
                </Button>
                <Button type='submit'>Filtrar</Button>
              </Row>
            )}
          </footer>
        </Form>
      </Drawer>
      {/*  <Modal open={isOpenModal} onClose={() => setIsOpenModal(!isOpenModal)} typeCampagin={handleTypeCampaign} /> */}
    </Body>
  )
}

export default Campaigns
